<template>
  <v-card
    :to="'/product/' + product.slug"
    class="mx-auto"
    max-width="1000"
    variant="outlined"
  >
    <v-img
      class="grey lighten-2"
      height="100%"
      width="100%"
      aspect-ratio="1"
      :src="getImage('/' + product.cover)"
    ></v-img>

    <v-card-text length="10" style="height: 80px; overflow: hidden">
      {{ product.title }}</v-card-text
    >

    <v-card class="mx-auto" elevation="0">
      <v-rating
        :value="rating"
        color="orange"
        size="14"
        background-color="orange"
      ></v-rating>

      <!-- <v-icon color="success">mdi-cash</v-icon> -->
      <span class="black--text" v-if="product.priceTmp == null">
        Rp {{ parseInt(product.price).toLocaleString("id-ID") }}
      </span>
      <span class="text-decoration-line-through" v-if="product.priceTmp != null">
        Rp
        {{ parseInt(product.priceTmp).toLocaleString("id-ID") }}
      </span>
      <br />
      <span class="red--text" v-if="product.priceTmp != null">
        Rp {{ parseInt(product.price).toLocaleString("id-ID") }}
      </span>

      <v-spacer></v-spacer>
      <v-icon color="success">mdi-store-search-outline</v-icon> {{ product.views }}
    </v-card>
  </v-card>
</template>
<script>
export default {
  name: "product-item",
  props: ["product"],
  data: () => ({}),
};
</script>
